import React from 'react'
import Viewer from './components/Viewer/Viewer'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useParams
} from "react-router-dom";
export default function App() {
  return (
    <div>
    <Viewer/>
    <Router>
      <Routes>
        <Route path="/:id" element={<Viewer />}></Route>
      </Routes>
    </Router>
    </div>
  )
}

